export const RegistrationDetailsSkeleton = () => {
	return (
		<div className="pt-4 md:pt-8">
			<div className="animate-pulse rounded-xl bg-white p-4 shadow-md md:p-8">
				<h3 className="mb-4 h-6 w-48 rounded bg-gray-200"></h3>
				<div className="mt-4 flex flex-col">
					<div className="mb-2 flex">
						<div className="h-4 w-20 rounded bg-gray-200"></div>
					</div>
					<div className="mb-2 flex">
						<div className="h-4 w-28 rounded bg-gray-200"></div>
					</div>
					<div className="mb-2 flex">
						<div className="h-4 w-24 rounded bg-gray-200"></div>
					</div>
				</div>
			</div>
		</div>
	);
};
